import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SidenavService } from '../../services/sidenav.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor(private title: Title,
    private sidenavService: SidenavService) {     
    this.title.setTitle('Taiga - Dashboard');
    this.sidenavService.currentTab = 'Dashboard';
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.component.ts